import React, { Component } from 'react';
import UserForm from './UserForm';
import Edit from '../../common/Edit';
export default class UserEdit extends Component {
  render() {
    return (
      <Edit
        resource={'user'}
        resourceId={this.props.params.id}
        component={UserForm}
      />
    );
  }
}
